// 部品 ボタン左右均等割り用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const RowJustifyButton: React.FC = ({ children }) => {
  return (
    <Row className="row-justify-button">
      <Col className="text-center">{children}</Col>
    </Row>
  );
};

export default RowJustifyButton;
